module.exports = __webpack_public_path__ + "static/img/合作伙伴.bae8260.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/合作伙伴.png
// module id = sB7g
// module chunks = 45